import React, { useContext } from "react";
import { Preview } from "@creatomate/preview";

import { t } from "app/utils";
import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import SubtitleTab from "./SubtitleTab";

interface SubtitlesTabsProps {
  availableLanguages: string[];
  activeLanguageCode?: string;
  changingLanguage: boolean;
  onLanguageChange: (language: string) => void;
  preview: Preview;
}

const SubtitleTabs: React.FC<SubtitlesTabsProps> = ({
  availableLanguages,
  activeLanguageCode,
  changingLanguage,
  onLanguageChange,
  preview
}) => {
  const { data: { pendingSubtitle, story } } = useContext(CreatomateContext);

  return (
    <ul role="tablist" aria-label={t("Subtitles options")} className="nav nav-tabs">
      {pendingSubtitle && (
        <SubtitleTab
          activeLanguageCode={activeLanguageCode}
          language={pendingSubtitle.language || ""}
          loading
          onLanguageChange={onLanguageChange}
          preview={preview}
          story={story}
        />
      )}
      {availableLanguages.map((language, index) => (
        <SubtitleTab
          activeLanguageCode={activeLanguageCode}
          changingLanguage={changingLanguage}
          key={index}
          language={language}
          onLanguageChange={onLanguageChange}
          preview={preview}
          story={story}
        />
      ))}
    </ul>
  );
};

export default SubtitleTabs;
